import React from "react";
import data from "../../Json/Aboutpage/aboutsection1.json";

const Aboutsection1 = () => {
  return (
    <div className="w-full flex flex-col justify-center">
      <div className=" w-full relative h-[300px] lg:h-[450px] xl:h-[400px] bg-aboutbg overflow-hidden flex items-center justify-center ">
        <div className="absolute top-0 inset-y-0  -z-10 w-full">
          <video id="backgroundvideo" className="max-sm:object-cover max-sm:h-full w-full" autoPlay muted loop>
            <source
              src={process.env.PUBLIC_URL + data.videourl}
              type="video/mp4"
            />
          </video>
        </div>
        <div className="relative z-10 w-10/12 lg:w-8/12 flex flex-col gap-4 items-center text-center">
          <h1 className="text-20 sm:text-24 lg:text-28 text-white ">{data.Title}</h1>
          <div className="h-[1px] w-10 bg-button"></div>
          <h2 className="text-white text-20 sm:text-24 lg:text-40">{data.about}</h2>
        </div>
      </div>
      {/* <div className="py-10 px-4 lg:p-20 flex flex-col lg:flex-row items-center gap-10 lg:gap-0 lg:space-x-[120px] 2xl:container mx-auto lg:px-20 md:px-10 px-6 w-full">
        <div className="w-full lg:w-2/3 flex flex-col gap-6">
          <p className="text-base lg:text-18 text-logoorange">{data.para1}</p>
          <p className="text-base lg:text-18 secondaryblack">{data.para2}</p>
        </div>
        <div className="w-full lg:w-1/3">
          <img src={process.env.PUBLIC_URL + data.imgurl} alt="aboutimg" />
        </div>
      </div> */}
      
    </div>
  );
};

export default Aboutsection1;